import $ from "jquery";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class OperatorSorters extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;
        var operators = Comm.Operators(sid);

        this.state = {
            Operators: operators,
            SelectedOperator: null,
        };

        this.Save = this.Save.bind(this);
    }

    ShowOperator(operator) {
        var sid = Context.GetContext().Sid;

        operator.sorters = Comm.GetOperatorSorters({
            session: sid,
            operator: operator.operator.id,
        });
        this.setState({ SelectedOperator: operator });
    }

    Save() {
        var sid = Context.GetContext().Sid;

        var sorters = [];
        $("input[id^='cbSorter']:checked").each(function (i, e) {
            var val = $(e).attr("permvalue");
            sorters.push(val);
        });
        var data = {
            session: sid,
            operator: this.state.SelectedOperator.operator.id,
            sorter_ids: JSON.stringify(sorters),
        };
        Comm.SaveOperatorSorters(data);

        this.setState({
            SelectedOperator: null,
        });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        return Context.HasRight("roperatorsorters") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("operator2sorter")}</div>
                <div className="panel-body">
                    <br />
                    <div className="row">
                        <div className="col-md-5">
                            {this.state.Operators.map((obj) => (
                                <p
                                    className={
                                        this.state.SelectedOperator !== null &&
                                        this.state.SelectedOperator.operator.id === obj.operator.id
                                            ? "btn btn-warning"
                                            : null
                                    }
                                >
                                    <a onClick={() => this.ShowOperator(obj)} className="pointhand">
                                        {obj.operator.name}
                                    </a>
                                </p>
                            ))}
                        </div>
                        <div className="col-md-7">
                            {this.state.SelectedOperator !== null ? (
                                <div id="dData" className="borderDiv">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {Context.HasRight("eoperatorsorters") ? (
                                                <button
                                                    className="btn btn-primary pull-right"
                                                    onClick={this.Save}
                                                >
                                                    {Translation.Trans("save")}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="row scrollableDiv">
                                        <div className="col-md-6">
                                            {this.state.SelectedOperator.sorters.map((obj) =>
                                                obj.visible ? (
                                                    <div className="checkbox">
                                                        <input
                                                            id={"cbSorter" + obj.id}
                                                            type="checkbox"
                                                            permvalue={obj.id}
                                                            key={
                                                                obj.id +
                                                                "_" +
                                                                this.state.SelectedOperator.operator.id
                                                            }
                                                            defaultChecked={obj.checked}
                                                        />
                                                        <label for={"cbSorter" + obj.id}>{obj.name}</label>
                                                    </div>
                                                ) : null
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default OperatorSorters;



// WEBPACK FOOTER //
// ./src/pages/operatorsorters.js